import { render, staticRenderFns } from "./_detail_storehouse.vue?vue&type=template&id=66174786&scoped=true&"
import script from "./_detail_storehouse.vue?vue&type=script&lang=js&"
export * from "./_detail_storehouse.vue?vue&type=script&lang=js&"
import style0 from "./_detail_storehouse.vue?vue&type=style&index=0&id=66174786&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66174786",
  null
  
)

export default component.exports